'use strict';

/**
 * @ngdoc function
 * @name thothApp.controller:EmployeeNewCtrl
 * @description
 * # EmployeeNewCtrl
 * Controller of the thothApp
 */
angular.module('thothApp.controllers')
  .controller('EmployeeNewCtrl', [
    '$scope', '$state', '$stateParams', 'Employee', 'User', 'Workspace', 'EmployeePosition', function ($scope, $state, $stateParams, Employee, User, Workspace, EmployeePosition) {
    $scope.usersList = [];

    Workspace.index().then(function(response) {
      $scope.workspaces = response.data.workspaces
      },function(error) {
        Workspace.error(error);
    });

    EmployeePosition.index().then(function(response) {
      $scope.employee_positions = response.data.employee_position
      },function(error) {
        Employee.error(error);
    });

    if($stateParams.employeeId) {
      Employee.find($stateParams.employeeId).then(function(response) {
        $scope.employeeHash = { 'employee': response.data.employee };
      }, function(error) {
        Employee.error(error);
      });
    } else {
      $scope.employeeHash = {
        'employee': {
          'name': '',
          'employee_code': '0',
          'user_id': '',
          'is_rape': false,
          'is_active': 1,
          'workspace_id': 10,
          'employee_position_id': null,
          'assignable': false
        }
      };
    }

    User.index({params: { per_page: 'all' } }).then(function(response) {
      $scope.usersList = response.data.users;
    }, function(error) {
      User.error(error);
    });

    $scope.saveEmployee = function() {
      Employee.save($scope.employeeHash).then(function(response) {
        $scope.employeeHash = {
          'employee': {
            'name': '',
            'employee_code': '0',
            'user_id': '',
            'is_rape': false,
            'is_active': 1,
            'workspace_id': 10,
            'employee_position_id': null,
            'assignable': false
          }
        };
        // TODO: Toast message se creo con exito
        $state.go('app.employees.list');
      }, function(error) {
        Employee.error(error);
      });
    };
  }]);
